import React, { Component } from "react";
import { Collapse, CardBody, Card } from "reactstrap";
import { NavLink } from "react-router-dom";
import "./MobileMenu.css";
import { EquipementData } from "../../../../api/EquipementData";
import { BtpData } from "../../../../api/BtpData";
import { NetoyageData } from "../../../../api/NetoyagaData";

const menuGehl = [
  {
    id: 1,
    title: "Accueil",
    link: "/",
  },

  {
    id: 2,
    title: "Equipement",
    link: "/equipement",
    submenu: EquipementData.map((equipement) => {
      return {
        id: equipement.id,
        title: equipement.title,
        link: `/equipement/single/${equipement.id}`,
      };
    }),
  },

  {
    id: 3,
    title: "Accessoires",
    link: "/accesoires/1",
  },
  {
    id: 4,
    title: "A propos",
    link: "/about",
  },

  {
    id: 7,
    title: "Contactez-Nous",
    link: "/contact",
  },
  {
    id: 8,
    title: "Autres",
    link: "/others",
  },
];

const menuOther = [
  {
    id: 1,
    title: "Accueil",
    link: "/others",
  },

  {
    id: 2,
    title: "BTP",
    link: "/others/btp",
    submenu: BtpData.map((btp) => {
      return {
        id: btp.id,
        title: btp.title,
        link: `/others/btp/single/${btp.id}`,
      };
    }),
  },
  {
    id: 3,
    title: "Nettoyage",
    link: "/others/btp",
    submenu: NetoyageData.map((net) => {
      return {
        id: net.id,
        title: net.title,
        link: `/others/nettoyage/single/${net.id}`,
      };
    }),
  },
  {
    id: 4,
    title: "A propos",
    link: "/others/about",
  },

  {
    id: 7,
    title: "Contactez-Nous",
    link: "/others/about",
  },
  {
    id: 8,
    title: "GEHL",
    link: "/",
  },
];

export default class MobileMenu extends Component {
  state = {
    isMenuShow: false,
    isOpen: 0,
    menu: menuGehl,
    pathname: "",
  };

  // location = useLocation();

  componentDidMount() {
    // console.log("FIRST RENDER LOCATION", window.location.pathname);
    this.setState({
      pathname: window.location.pathname,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("update LOCATION", window.location.pathname);
    if (prevState.pathname !== window.location.pathname) {
      this.setState({
        pathname: window.location.pathname,
      });

      if (this.state.pathname.includes("others")) {
        console.log("INCLUDE OTHERS");
        this.setState({
          menu: menuOther,
        });
      } else {
        this.setState({
          menu: menuGehl,
        });
      }
    }
  }

  menuHandler = () => {
    this.setState({
      isMenuShow: !this.state.isMenuShow,
    });
  };

  setIsOpen = (id) => () => {
    this.setState({
      isOpen: id === this.state.isOpen ? 0 : id,
    });
  };

  render() {
    const { isMenuShow, isOpen } = this.state;

    const ClickHandler = () => {
      window.scrollTo(10, 0);
      this.setState({
        isMenuShow: !this.state.isMenuShow,
      });
    };

    return (
      <div>
        <div className={`mobileMenu ${isMenuShow ? "show" : ""}`}>
          <div className="menu-close">
            <div className="clox" onClick={this.menuHandler}>
              <i className="ti-close"></i>
            </div>
          </div>

          <ul className="responsivemenu">
            {this.state.menu.map((item) => {
              return (
                <li key={item.id}>
                  {item.submenu ? (
                    <p onClick={this.setIsOpen(item.id)}>
                      {item.title}
                      {item.submenu ? (
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      ) : (
                        ""
                      )}
                    </p>
                  ) : (
                    <NavLink onClick={ClickHandler} to={item.link}>
                      {item.title}
                    </NavLink>
                  )}
                  {item.submenu ? (
                    <Collapse isOpen={item.id === isOpen}>
                      <Card>
                        <CardBody>
                          <ul>
                            {item.submenu.map((submenu) => (
                              <li key={submenu.id}>
                                <NavLink
                                  onClick={ClickHandler}
                                  className="active"
                                  to={submenu.link}
                                >
                                  {submenu.title}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </CardBody>
                      </Card>
                    </Collapse>
                  ) : (
                    ""
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        <div
          className={` ${isMenuShow ? "overlay" : ""}`}
          onClick={this.menuHandler}
        ></div>
        <div className="showmenu" onClick={this.menuHandler}>
          <button type="button" className="navbar-toggler open-btn">
            <span className="icon-bar first-angle"></span>
            <span className="icon-bar middle-angle"></span>
            <span className="icon-bar last-angle"></span>
          </button>
        </div>
      </div>
    );
  }
}
